<template>

    <v-checkbox-group>
        <div v-for="s in filteredSections" class="section" :key="s.id" v-show="!s.slug.includes('settings-') || showAllSettings">
            <v-checkbox
                :label="s.label"
                :model="ids.indexOf(s.id) >= 0"
                :disabled="member && ['owner', 'super-admin'].includes(member.role.slug) ? true : false"
                @input="toggleSection(s)">
            </v-checkbox>
            <div v-if="s.slug === 'settings' && ids.indexOf(s.id) >= 0" class="more" @click="showAllSettings = !showAllSettings">
                <i v-if="showAllSettings" class="fas fa-caret-up" />
                <i v-else class="fas fa-caret-down" />
            </div>
        </div>
    </v-checkbox-group>

</template>

<style lang="scss">

    .section {
        align-items: center;
        display: flex;
        .more {
            color: $color-text;
            cursor: pointer;
            display: inline-block;
            font-size: 12px;
            text-align: center;
            width: 20px;
        }
    }

</style>

<script>

export default {

    props: {
        model: {
            type: Array,
            required: true,
        },
        member: {
            type: Object,
        },
    },

    data() {
        return {
            ids: this.model,
            showAllSettings: false,
        }
    },

    computed: {

        sections() {
            return this.$store.getters.app.sections;
        },

        filteredSections() {
            let sections = this.sections.map(s => ({ ...s, label: this.makeLabel(s.slug) }));
            if (!this.hasSettings) {
                return sections.filter(s => !s.slug.includes('settings-'));
            }
            return sections;
        },

        settingsSection() {
            return this.sections.find(s => s.slug === 'settings');
        },

        hasSettings() {
            if (!this.settingsSection) return false;
            return this.ids.includes(this.settingsSection.id);
        },

    },

    methods: {

        makeLabel(slug) {
            let key = slug.replace('settings-', '').replace('-', '_');
            if (slug.includes('settings-')) {
                return this.$t(`labels.settings`) + ' - ' + this.$t(`labels.${key}`);
            }
            return this.$t(`labels.${key}`);
        },

        toggleSection(val) {
            const index = this.ids.findIndex(i => i === val.id);
            if (index >= 0) {
                this.ids.splice(index, 1);
            } else {
                this.ids.push(val.id);
            }

            // Add or remove nested setting sections.
            if (val.id === this.settingsSection.id) {
                let settingIds = this.sections.filter(s => s.slug.includes('settings-')).map(s => s.id);
                if (index >= 0) {
                    this.ids = this.ids.filter(id => !settingIds.includes(id));
                } else {
                    settingIds.forEach(id => {
                        if (!this.ids.includes(id)) {
                            this.ids.push(id);
                        }
                    });
                }
            }

            this.$emit('input', this.ids);
        },

    },

}

</script>